<form id="generalForm" [formGroup]="form">
  <div class="mb-3 w-25">
    <div>
      <label for="invoicingGroup" class="form-label text-primary">
        {{ 'ERP::EnumerationCategory:InvoicingGroup' | abpLocalization }}
      </label>
      <ng-select
        class="form-control"
        formControlName="invoicingGroup"
        bindLabel="name.current"
        bindValue="id"
        [loading]="enumerationTypeStore.loading()"
        [items]="enumerationTypeStore.invoicingGroups()"
        (change)="filterDeliveryNotes($event)"
      >
      </ng-select>
    </div>
  </div>
</form>
<document-lines-editor
  #lineGrid
  [columnDefs]="columnDefs"
  [rows]="lines"
  [treeData]="false"
  [isDialogBox]="true"
  [fillRemainingHeight]="false"
  [domLayout]="'autoHeight'"
>
</document-lines-editor>
